import { find, get } from "lodash";
import { useRouter } from "next/router";
import { classNames } from "primereact/utils";
import { useState } from "react";
import { Chip, FadeIn } from "../../../../common/components";
import { useDevices } from "../../../devices/api";
import { useModes } from "../../../energy/api/useModes";
import { MODE_ICONS } from "../../../energy/constants";
import { getModeDeviceStatus } from "../../../energy/utils";
import { ActiveModeModal } from "./ActiveModeModal";

interface ActiveModeChipProps {
    className?: string;
}

const ActiveModeChip = (props: ActiveModeChipProps) => {
    const { className = null } = props;

    const [isModalOpen, setIsModalOpen] = useState(false);

    const router = useRouter();
    const { companyId, locationId } = router.query as {
        companyId?: string;
        locationId?: string;
    };

    const { modes } = useModes({
        companyId,
        locationId,
    });

    const { devices } = useDevices({
        companyId,
        locationId,
    });

    const activeMode = find(modes, "active") ?? null;

    const { hasFanCoils, hasRadiatorThermostats } = getModeDeviceStatus(
        activeMode,
        devices
    );

    return activeMode ? (
        <>
            <FadeIn>
                <Chip
                    onClick={() => setIsModalOpen(true)}
                    icon={get(MODE_ICONS, activeMode.icon!, null)}
                    label={activeMode.name}
                    className={classNames(
                        "h-7 rounded-full border-transparent bg-transparent px-2.5 text-sm text-primary-text/70 hover:bg-surface-500/15 [&_svg]:size-4",
                        className
                    )}
                    pt={{
                        label: {
                            className: "hidden sm:inline ml-1",
                        },
                    }}
                />
            </FadeIn>
            <ActiveModeModal
                isOpen={isModalOpen}
                hasFanCoils={hasFanCoils}
                hasRadiatorThermostats={hasRadiatorThermostats}
                mode={activeMode}
                onClickClose={() => setIsModalOpen(false)}
            />
        </>
    ) : null;
};

export default ActiveModeChip;
